var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62753 9.06293C4.20995 9.4781 3.53578 9.48094 3.11236 9.05997L0.693603 6.6552C0.274377 6.2384 0.265127 5.57182 0.688077 5.15132L0.67062 5.16868C1.08679 4.75491 1.76445 4.7578 2.17173 5.16272L3.87144 6.8526L9.81889 0.939539C10.2364 0.524463 10.9054 0.516665 11.3284 0.937169L11.3109 0.919813C11.7271 1.33358 11.7331 1.99841 11.3084 2.42073L4.62753 9.06293Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.02bb396db7e25290f1dd3b9fc05303ad.svg";
export { ForwardRef as ReactComponent };